import { render, staticRenderFns } from "./EvaluacionSeleccionTab.vue?vue&type=template&id=34622e50&"
import script from "./EvaluacionSeleccionTab.vue?vue&type=script&lang=js&"
export * from "./EvaluacionSeleccionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports